import Vuex from 'vuex'

import DataErrorsPopupModal from '@/components/app-core/modals/data-errors-popup'

export default {

    computed: {

        ...Vuex.mapState({
            /**
             * @param {VuexState} stateStore
             * @returns {Array<string>}
             */
            errors: stateStore => stateStore.myHome.errors,
        }),

        /**
         * @returns {boolean}
         */
        routeIsEditor() {
            return this.$route.name === 'MyHomeEdit'
        },

        /**
         * @returns {boolean}
         */
        hasErrors() {
            return !!this.errors.length
        },

        /**
         * @returns {boolean}
         */
        showErrors() {
            return this.hasErrors && !this.routeIsEditor
        },
    },

    mounted() {
        if (this.showErrors)
            this.displayPropertyErrors()
    },

    methods: {

        /**
         * Displays the property errors modal.
         */
        displayPropertyErrors() {
            this.$eventbus.$emit(this.$appevents.showModal, DataErrorsPopupModal, {
                data: {},
                cssModifier: 'data-errors',
            })
        },
    },
}
